export default "__VITE_ASSET__DXE5KSRF__"